import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import _ from 'underscore';
import { IObject } from '@type_definitions/datatypes';
import { util } from '@app/shared/util';

@Component({
  selector: 'c-checkbox-list',
  template: `
    <ng-template #checkboxTpl let-possibleValue="possibleValue" let-id="id">
      <fieldset [disabled]="isDisabled(possibleValue)">
        <input class="form-check-input" type="checkbox" [checked]="partOfModel(possibleValue)" (click)="updateModel(possibleValue)" [id]="id" [ngClass]="getClassNames(possibleValue)" />
        <label [for]="id" class="form-check-label checkbox-text" [innerHTML]="formattingFunction(possibleValue)" [title]="formattingFunction(possibleValue)"></label>
      </fieldset>
    </ng-template>
    
    <ng-container *ngIf="columns">
      <div class="checkbox-control checkbox-list">
        <div class="checkbox-column float-start" *ngFor="let checkboxColumn of checkboxColumns; let parentIndex = index;">
          <div class="form-check checkbox" *ngFor="let possibleValue of checkboxColumn; let childIndex = index;">
            <ng-container [ngTemplateOutlet]="checkboxTpl" [ngTemplateOutletContext]="{ possibleValue: possibleValue, id: key + '_' + parentIndex + '_' + childIndex }"></ng-container>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </ng-container>
    
    <ng-container *ngIf="!columns">
      <div class="checkbox-control checkbox-list">
        <div class="form-check checkbox" *ngFor="let possibleValue of possibleValues; let idx = index;">
          <ng-container [ngTemplateOutlet]="checkboxTpl" [ngTemplateOutletContext]="{ possibleValue: possibleValue, id: key + '_' + idx }"></ng-container>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['c-checkbox-list.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CCheckboxListComponent implements OnChanges {
  @Input() public key:string;
  @Input() public values: IObject[];
  @Input() public possibleValues: IObject[];
  @Input() public formatFunction: (...args: any[]) => string;
  @Input() public disabledFunction: (...args: any[]) => boolean;
  @Input() public columns: number;
  @Input() public formatFunctionParams: any[];
  @Input() public disabledFunctionParams: any[];

  @Output() public onSelectValue: EventEmitter<IObject[]> = new EventEmitter<IObject[]>();

  public checkboxColumns: Array<IObject[]>;

  constructor() {
    /**/
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // auto generate columns the list of possible values
    if (changes.possibleValues) {
      const possibleValues: any[] = changes.possibleValues.currentValue;

      this.checkboxColumns = [];
      const numPerCol = Math.ceil(possibleValues.length / this.columns);
      for (let i = 0; possibleValues && i < possibleValues.length; i++) {
        const colIdx = Math.floor(i / numPerCol);
        this.checkboxColumns[ colIdx ] = this.checkboxColumns[ colIdx ] || [];
        this.checkboxColumns[ colIdx ].push(possibleValues[ i ]);
      }
    }
  }

  public updateModel(possibleValue: IObject): void {
    const index:number = util.indexOf(this.values, possibleValue);
    if (index === -1) {
      this.values.push(possibleValue);
    } else {
      this.values.splice(index, 1);
    }

    this.onSelectValue.emit(this.values);
  }

  public partOfModel(possibleValue: IObject): boolean {
    return util.indexOf(this.values, possibleValue) !== -1;
  }

  public formattingFunction(possibleValue: IObject | any): string {
    if (this.formatFunction) {
      if (this.formatFunctionParams) {
        const params: any[] = _.map(this.formatFunctionParams, (param: any) => param === 'possibleValue' ? possibleValue : param);
        return this.formatFunction.apply(undefined, params);
      } else {
        return this.formatFunction(possibleValue);
      }
    } else {
      return <string>possibleValue;
    }
  }

  public isDisabled(possibleValue: IObject | any): boolean {
    if (this.disabledFunction) {
      if (this.disabledFunctionParams) {
        const params: any[] = _.map(this.disabledFunctionParams, (param: any) => param === 'possibleValue' ? possibleValue : param);
        return this.disabledFunction.apply(undefined, params);
      }
      else {
        return this.disabledFunction(possibleValue);
      }
    }
    return false;
  }

  public getClassNames(label:string):string {
    label = util.processLabel(this.formattingFunction(label));
    return label ? `checkbox-label-${label}` : '';
  }
}